import type { LegalAgreement } from "../Models/Domain/LegalAgreement";
import type { LegalAgreementApi } from "../Models/Api/LegalAgreement";
import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";

import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

import camelize from "@/Utils/Camelize";

const LegalAgreementTransformer: TransformerExtended<LegalAgreement, LegalAgreementApi> = {
  ...DefaultTransformerGenerator<LegalAgreement, LegalAgreementApi>(),

  toDomain(input) {
    return camelize<LegalAgreementApi>(input, [
      "contractor_signed_date",
      "contractor_uuid",
      "contracted_signed_date",
      "contracted_uuid",
      "document_name",
      "document_uuid",
      "template_name",
      "uuid",
      "html",
    ]) as LegalAgreement;
  },
};

export type LegalAgreementTransformerType = TransformerExtended<LegalAgreement, LegalAgreementApi>;

export default LegalAgreementTransformer;
